import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


export const useFetchEdge = ({ flowId, edgeId }) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);
  const isEnabled = !!edgeId && !!flowId;

  const {
    isLoading, isError, isSuccess, data, refetch, isRefetching,
  } = useQuery(
    ['Fetch-Edge', orgId, edgeId],
    async () => axiosInstance.get(flow(orgId).fetchEdge(flowId, edgeId)),
    {
      onError: (error) => dispatch(showAlert({ message: error.response.data.message, type: 'error' })),
      refetchOnWindowFocus: true,
      enabled: isEnabled,
    },
  );

  return {
    isLoading, isError, isSuccess, data, refetch, isRefetching,
  };
};
